/**
 * Copyright © 2026 Adnuntius AS.
 */

export default [
  {
    type: 'PoliticalEntity',
    labelOverride: 'Controlling Entity',
    resolve: function(data) {
      const o = data._politicalCampaignCrumbOwning;
      if (!o || !o.id) {
        return null;
      }
      if (o.type === 'SPONSOR') {
        const p = o.parent;
        if (p && p.id) {
          return {id: p.id, name: p.name || 'Controller'};
        }
        return null;
      }
      return {id: o.id, name: o.name || 'Entity'};
    }
  },
  {
    type: 'PoliticalEntity',
    labelOverride: 'Sponsor',
    resolve: function(data) {
      const o = data._politicalCampaignCrumbOwning;
      if (!o || o.type !== 'SPONSOR' || !o.id) {
        return null;
      }
      return {id: o.id, name: o.name || 'Sponsor'};
    }
  }
];
